import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { IdentificationDocument } from './identification-document';
export { IdentificationDocument };
import { identificationDocumentSchema } from '@schemas/business-objects/identification-document';
import { CandidateFormGroup } from './candidate-form-group';

export class IdentificationDocumentFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    documentNumber: SchemaFormControl;
    pinCode: SchemaFormControl;
    issuingAuthority: SchemaFormControl;
    dateOfIssue: SchemaFormControl;
    dateOfExpiry: SchemaFormControl;
    visaNumber: SchemaFormControl;
    visaExpirationDate: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
  };

  declare value: Partial<IdentificationDocument>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(identificationDocumentSchema, IdentificationDocument, data, options);
  }

  get object(): IdentificationDocument {
    return new IdentificationDocument(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      default:
        return undefined;
    }
  }
}

export class IdentificationDocumentFormArray extends PersistedFormArray {
  readonly entityName = 'IdentificationDocument' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(identificationDocumentSchema, IdentificationDocument, options);
  }

  protected override createItemGroup() {
    return new IdentificationDocumentFormGroup();
  }

  get array(): IdentificationDocument[] {
    return this.controls.map(
      (group: IdentificationDocumentFormGroup) => group.object,
    );
  }
}

export class IdentificationDocumentPersistedArray extends PersistedArray<IdentificationDocument> {
  readonly entityName = 'IdentificationDocument' as const;

  constructor(options?: PersistedArrayOptions) {
    super(IdentificationDocument, options);
  }
}
